// import location from "../../images/highlights/location.png";
import virtual from "../../images/highlights/virtual.png";
// import flag from "../../images/highlights/flag.png";
import flag from "../../images/highlights/rectangle-flag.png";
// import building from "../../images/illustrations/building.png";
import building_zoom from "../../images/illustrations/building-zoom.png";


function AvailabilitySection() {

    return (
        <section className="section-colour">
            <div className="bottom-margin-1em">
                <h3>Accessibility</h3>
                <div className="highlights">
                    <div className="feature">
                        <img className="oval-image adjust-oval" src={flag} alt="language" />
                        <div>
                            <h5>Language Support</h5>
                            <p>Sessions can be in English and/or French</p>
                        </div>
                    </div>
                    <div className="feature">
                        {/* <img src={location} alt="location" /> */}
                        {/* <img src={building} alt="location" /> */}
                        <img className="oval-image" src={building_zoom} alt="location" />
                        <div>
                            <h5>Location</h5>
                            <p>I work across London in different locations</p>
                        </div>
                    </div>
                    <div className="feature">
                        <img src={virtual} alt="laptop" />
                        <div>
                            <h5>In-Person or Virtual</h5>
                            <p>Sessions can be both online and/or in person</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AvailabilitySection;